export default __webpack_public_path__ + "static/media/SEG-Library-Seismic-Soundoff-logo.1160afd3.png";